import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import $ from 'jquery';
import { injectIntl } from 'react-intl';
import BookingDetailsActionCreator from 'action_creators/booking_details';
import IntegrationActionCreator from 'action_creators/integration';
import GlanceView from 'views/shared/tours/page/glance';
import PropsMixin from 'views/shared/tours/page/glance/mixin';
import StoreInterest from 'lib/flux/store/interest_mixin';

import './index.scss';

const GlanceWrapperComponent = createReactClass({
  displayName: 'Plugins-TourPage-GlanceWrapper',

  propTypes: {
    includes_transport: PropTypes.bool.isRequired,
    is_recurrent: PropTypes.bool.isRequired,
    available_on_a_few_dates: PropTypes.bool.isRequired,
    booking_request_path: PropTypes.string.isRequired,
    availability_dates: PropTypes.string,
    is_available: PropTypes.bool,
    should_redirect: PropTypes.bool,
  },

  mixins: [PropsMixin, StoreInterest],

  getDefaultProps() {
    return {
      availability_dates: '',
      is_available: true,
    };
  },

  getInitialState() {
    return {
      originUrl: null,
    };
  },

  getStoreInterests() {
    return {
      originUrl: 'booking_details.originUrl',
    };
  },

  componentDidMount() {
    IntegrationActionCreator.queryOriginUrl();
  },

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  },

  _isMobile() {
    return (
      window.mobileDetect !== undefined && window.mobileDetect.phone() !== null
    );
  },

  _getPluginParam() {
    // Returns slug of Plugin if in that context
    const currentUrlParsed = window.location.href.split('/');
    const indexOfPlugin = currentUrlParsed.indexOf('plugin');

    if (indexOfPlugin !== -1) {
      return currentUrlParsed[indexOfPlugin + 1];
    }

    return null;
  },

  _availabilityLink() {
    const { intl } = this.props;
    const text = intl.formatMessage({
      defaultMessage: 'View Calendar',
      description: 'Link text to view the availability calendar',
    });
    let onClick;
    const _this = this;
    const {
      is_available: isAvailable,
      should_redirect: shouldRedirect,
      context,
    } = this.props;

    if (this._isMobile()) {
      onClick = function (e) {
        const navTo = _.addToURLParams(_this.props.booking_request_path, {
          origin_url: _this.state.originUrl || window.location.href,
          context,
          lang: intl.locale,
          plugin: _this._getPluginParam(),
        });

        e.preventDefault();
        if (isAvailable) {
          if (shouldRedirect) {
            IntegrationActionCreator.redirect_to(navTo);
          } else {
            window.location = navTo;
          }
        }
      };
    } else {
      onClick = function (e) {
        e.preventDefault();
        if (isAvailable) {
          const selector = '#price-container'; // The start of the page suits both desktop and tablet layouts. Scroll there.

          _this._scrollToBookingForm(selector);
          IntegrationActionCreator.scrollToSelector(selector);
          BookingDetailsActionCreator.showForm();
          BookingDetailsActionCreator.showDates();
        }
      };
    }

    if (!isAvailable) return <div />;

    return (
      <>
        {this.props.has_multiple_locations ? (
          <div>
            <span style={{ verticalAlign: 'middle' }}>
              {' '}
              {text}{' '}
              {intl.formatMessage({
                defaultMessage: 'to see all dates',
                description:
                  'Text explaining that viewing the calendar will show all available dates',
              })}
            </span>
          </div>
        ) : (
          <div>
            <a
              data-testid="btn-calendar"
              style={{ textDecoration: 'none' }}
              href="#"
              className="btn-calendar brand-color"
              onClick={onClick}
            >
              {text}
            </a>
            <span style={{ verticalAlign: 'middle' }}>
              {' '}
              {intl.formatMessage({
                defaultMessage: 'to see all dates',
                description:
                  'Text explaining that viewing the calendar will show all available dates',
              })}
            </span>
          </div>
        )}
      </>
    );
  },

  _scrollToBookingForm(selector) {
    const el = $(selector);
    let formOffset;
    if (el.length > 0) {
      formOffset = el[0].getBoundingClientRect().top;
      if (formOffset < 0) {
        $(document.body).animate({
          scrollTop: document.body.scrollTop + formOffset,
        });
      }
    }
  },

  viewProps() {
    const { intl } = this.props;
    const props = {};

    props.transportation = this.props.includes_transport
      ? intl.formatMessage({
          defaultMessage: 'Includes pick up and drop-off',
          description:
            'Indicates that the tour includes transportation (pickup and drop-off)',
        })
      : null;
    if (this.props.available_on_a_few_dates) {
      props.availability = this.props.availability_dates;
    } else {
      props.availability = `Available ${
        this.props.is_recurrent ? 'all year' : 'on certain dates'
      }`;
    }

    props.iconClasses = _.extend({}, this._defaultIconClasses(), {
      duration: 'af-duration-2',
      people: 'af-people-2',
      transportation: this.props.includes_transport
        ? 'af-transport-yes'
        : 'af-transport-no',
      languages: 'af-language',
    });
    props.maxTimes = this._isMobile() ? 2 : 3;
    props.availabilityLink = this.props.available_on_a_few_dates
      ? null
      : this._availabilityLink();
    props.has_multiple_locations = this.props.has_multiple_locations;
    return _.extend({}, this.props, props);
  },

  render() {
    return (
      <div className="Plugins-TourPage-GlanceWrapper">
        <GlanceView {...this.viewProps()} />
      </div>
    );
  },
});

export const GlanceWrapper = injectIntl(GlanceWrapperComponent);
